export enum IceHockeyShotOffTargetAttribute {
  Snap = 962,
  Slap = 963,
  Wrist = 964,
  TipIn = 965,
  Backhand = 966,
  Shovel = 967,
  OneHanded = 968,
  WrapAround = 969,
}
